import React, { useEffect } from 'react';
import { SalesLandingPage } from './pages/SalesLandingPage';
import { initMetaPixel } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <SalesLandingPage data-id="element-0" />;
}